import { carryAdditionExplanation, createNaturalArithmeticTask, randInt } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 300; i += 1) {
    const a = randInt(2, 9);
    const b = randInt(2, 9);
    if (a + b >= 10) return { a, b, op: "+", result: a + b };
  }
  return { a: 7, b: 5, op: "+", result: 12 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalAddOneDigitCarryTask",
  pickData,
  explain: carryAdditionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
